module.exports = __webpack_public_path__ + "static/media/EG-P15.96950948.jpg";